<template>
	<div class="custom-layout-skeleton" :style="style"></div>
</template>

<script>
// Tiny shimmer placeholder. Compose multiple to draft a content skeleton
// (avatar circle, title bar, body lines, etc.). Width / height / radius
// are inline-styled per use site so a single component covers all
// skeleton shapes without one-off component files for each.
//
// Lives under /Shared/ rather than the Forum tree so any feature
// can drop a skeleton in without coupling to forum internals.
export default {
	name: "SkeletonLine",
	props: {
		width: { type: String, default: "100%" },
		height: { type: String, default: "10px" },
		radius: { type: String, default: "4px" },
		marginTop: { type: String, default: "0" },
	},
	computed: {
		style() {
			return {
				width: this.width,
				height: this.height,
				borderRadius: this.radius,
				marginTop: this.marginTop,
			};
		},
	},
};
</script>

<style scoped>
/* Two-layer shimmer: solid base + a translucent white band that slides
   across via translateX. translateX is GPU-accelerated, so the
   animation stays smooth even with many skeletons on screen. */
.custom-layout-skeleton {
	position: relative;
	display: block;
	background: #e2e2e2;
	overflow: hidden;
}

.custom-layout-skeleton::after {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(90deg,
			rgba(255, 255, 255, 0) 0%,
			rgba(255, 255, 255, 0.65) 50%,
			rgba(255, 255, 255, 0) 100%);
	transform: translateX(-100%);
	animation: custom-layout-skeleton-shimmer 1.6s infinite linear;
}

@keyframes custom-layout-skeleton-shimmer {
	100% {
		transform: translateX(100%);
	}
}

@media (prefers-reduced-motion: reduce) {
	.custom-layout-skeleton::after {
		animation: none;
		opacity: 0;
	}
}</style>
